module.exports = __webpack_public_path__ + "static/NU-hero-2a4ebd7b394776b6f9efd2df74ab7131.png";